module.exports = __webpack_public_path__ + "static/img/10061B_R_2_20171015_fit.3624968.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10061B_R_2_20171015_fit.png
// module id = LXu0
// module chunks = 0